import Text, { TEXT_VARIANT } from '@pixum/text';
import type { AsteriskTextProps } from './types';
import './styles.css';

/**
 * Asterisk text component displaying a text with an asterisk
 */
export function AsteriskText(props: AsteriskTextProps) {
  const { text } = props;

  return (
    <section className="asterisk main-section center--content">
      <Text variant={TEXT_VARIANT.FOOTNOTE}>{text}</Text>
    </section>
  );
}
